module.exports = "/images/oxxo.svg?b49db8d67a06f2f343f3123198708f8f";